import React from 'react'
import CopyLabel from '../copy/CopyDefinitions'
import Icon from './Icons'
import HeroDevice from './HeroDevice'
import {DOWNLOAD_ANDROID_APP_LINK,DOWNLOAD_IOS_APP_LINK} from '../externalLinks'
import Particles from 'react-particles-js'
import particlesConfig from './particlesConfig.json'

class HeroPhone extends React.Component{

  render() {
    

    return(
      <div className='heroPhoneContainer' >
        <div className='heroPhone'>

      		<div className='heroPhone-title'>
      		  <CopyLabel label='heroTitle'/>
      		</div>

      		<div className='heroPhone-sub'>
        		<CopyLabel label='heroSub1'/> <CopyLabel label='heroSub2'/>
        	</div>    		    		    		
      
          <div className='heroPhone-heroDeviceContainer'>
              <HeroDevice />
          </div>
        
          {this.props.mobileOS === 'Android' &&
        		<a className='heroPhone-sign-up-btn' href={DOWNLOAD_ANDROID_APP_LINK} >
        			<CopyLabel label='primarySignUpAndroid' />			
        		</a>
          }

          {this.props.mobileOS === 'iPhone' &&
            <a className='heroPhone-sign-up-btn' href={DOWNLOAD_IOS_APP_LINK} >
              <CopyLabel label='primarySignUpiPhone' />      
            </a>
          }

          {this.props.mobileOS === 'iPad' &&
            <a className='heroPhone-sign-up-btn' href={DOWNLOAD_IOS_APP_LINK} >
              <CopyLabel label='primarySignUpiPad' />      
            </a>
          }
          
        </div>
        <Particles params={particlesConfig}
          style={{
            position: 'absolute',
            bottom: '0px',
            right: '0px',
            left: '0px',
            bottom: '0px'
          }}
        />
      </div>
    )
  }
}

export default HeroPhone
